import type { BaseMeeting, BaseRace, MeetingId } from '@ps/web-sports-api-types';
import { pickBy } from 'lodash';
import type { Selector } from 'react-redux';

import type { RootState, SelectorCreator, Slicer } from '@swf/core/store';

import type { SportsAnimalRacingMeetingsState } from './types';

export const selectors = (
  slice: Slicer<SportsAnimalRacingMeetingsState>,
  createSelector: SelectorCreator
) => ({
  hasPreloaded: () => slice((state) => state.hasPreloaded),
  isLoading: () => slice((state) => state.isLoading),
  templateGroups: () => slice((state) => state.templateGroups),
  meetings: () => slice((state) => state.meetings),
  meeting(this: { meetings: Selector<RootState, SportsAnimalRacingMeetingsState['meetings']> }) {
    return createSelector(
      this.meetings,
      (state: RootState, meetingId: MeetingId) => meetingId,
      (meetings, meetingId): BaseMeeting => meetings[meetingId]
    );
  },
  races: () => slice((state) => state.races),
  meetingRaces(this: { races: Selector<RootState, SportsAnimalRacingMeetingsState['races']> }) {
    return createSelector(
      this.races,
      (state: RootState, meetingId: MeetingId) => meetingId,
      (races, meetingId): BaseRace[] =>
        Object.values(pickBy(races, (race) => race.meetingId === meetingId))
    );
  },
  errorCode: () => slice((state) => state.errorCode)
});
